var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Square Clock",
    clipPath: "url(#clip0_636_9294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square-clock--clock-loading-frame-measure-time-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99944 15.7142C11.515 15.7142 12.9684 15.1122 14.0401 14.0405C15.1117 12.9689 15.7137 11.5155 15.7137 9.99993C15.7137 8.48441 15.1117 7.03096 14.0401 5.95932C12.9684 4.88768 11.515 4.28564 9.99944 4.28564C8.48392 4.28564 7.03047 4.88768 5.95883 5.95932C4.8872 7.03096 4.28516 8.48441 4.28516 9.99993C4.28516 11.5155 4.8872 12.9689 5.95883 14.0405C7.03047 15.1122 8.48392 15.7142 9.99944 15.7142Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 7.85742V10.0003H12.1429",
    stroke: "#7F7F7F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.8567 0.714355H2.14244C1.76356 0.714355 1.4002 0.864865 1.13229 1.13277C0.864377 1.40068 0.713867 1.76405 0.713867 2.14293V17.8572C0.713867 18.2361 0.864377 18.5995 1.13229 18.8674C1.4002 19.1353 1.76356 19.2858 2.14244 19.2858H17.8567C18.2356 19.2858 18.599 19.1353 18.8669 18.8674C19.1348 18.5995 19.2853 18.2361 19.2853 17.8572V2.14293C19.2853 1.76405 19.1348 1.40068 18.8669 1.13277C18.599 0.864865 18.2356 0.714355 17.8567 0.714355Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_9294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSClock);
export default __webpack_public_path__ + "static/media/SClock.1e043720690c2d9471fc577e4e06de0e.svg";
export { ForwardRef as ReactComponent };